import { colors } from '@factorialco/deprecated-design-system'
import { BankingValueObjectsCardTypeEnum } from 'generated/resources/graphql'

const fontFamily = 'Oxanium'

export const customFont = {
  family: fontFamily,
  src: 'url(https://factorial-stripe-fonts.s3.eu-central-1.amazonaws.com/OCRAExtended/Oxanium-Medium.woff2)',
  display: 'block',
  weight: '400',
}
const commonBaseStyles = (cardType: BankingValueObjectsCardTypeEnum) => ({
  fontFamily: fontFamily,
  color: getTextColor(cardType),
  letterSpacing: '.14em',
  lineHeight: '1.4em',
  verticalAlign: 'normal',
})

export const cardNumberStyle = (cardType: BankingValueObjectsCardTypeEnum) => {
  const commonStyles = commonBaseStyles(cardType)

  return {
    base: {
      ...commonStyles,
      fontSize: '18px',
    },
  }
}

export const copyButtonStyle = {
  base: {
    lineHeight: '40px',
  },
}

export const cvvStyle = (cardType: BankingValueObjectsCardTypeEnum) => {
  const commonStyles = commonBaseStyles(cardType)

  return {
    base: {
      ...commonStyles,
      fontSize: '16px',
    },
  }
}
const getTextColor = (cardType: BankingValueObjectsCardTypeEnum): string => {
  const type: Record<BankingValueObjectsCardTypeEnum, string> = {
    physical: colors.grey1000,
    virtual: colors.grey000White,
    single_use: colors.grey000White,
  }

  return type[cardType] || colors.grey1000
}
